module.exports = __webpack_public_path__ + "static/category-shoes-1ed87b92d34b5bb17272c3ef3bfad8e0.jpg";